import { Button } from "@/components/ui/button";
import NewsCard from "@/components/NewsCard";
import Section from "@/components/Section";
import { getLatestNews } from "@/data/newsData";
import { Link } from "react-router-dom";

const LatestNews = () => {
  const latestArticles = getLatestNews(3);

  return (
    <Section
      surface="alt"
      eyebrow="Insights"
      title={<>Latest News &amp; <span className="text-gradient-brand">Insights</span></>}
      description="Updates on AI regulation, leadership, and the trends shaping responsible AI."
      containerSize="wide"
      grid
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {latestArticles.map((article) => (
          <NewsCard key={article.id} article={article} showExcerpt={false} />
        ))}
      </div>

      <div className="text-center">
        <Button variant="secondary" size="lg" asChild>
          <Link to="/news">View all news</Link>
        </Button>
      </div>
    </Section>
  );
};

export default LatestNews;
